import * as React from "react"
const SvgComponent = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    xmlSpace="preserve"
    style={{
      shapeRendering: "geometricPrecision",
      textRendering: "geometricPrecision",
      imageRendering: "optimizeQuality",
      fillRule: "evenodd",
      clipRule: "evenodd",
    }}
    viewBox="0 0 17949 15752"
    {...props}
  >
    <path
      d="M11296 7084c1349-2010 3393-4087 6396-6688-3059 2650-5490 4116-7852 4405-632-1365-866-2783-866-4545 0 1762-233 3180-865 4545C5747 4513 3316 3046 256 396c3004 2601 5048 4678 6397 6688-911 1125-2141 2322-3781 3742 1653-1432 3044-2371 4353-2818 1294 2267 1749 4540 1749 7488 0-2948 456-5221 1750-7488 1309 447 2699 1386 4353 2818-1640-1420-2870-2617-3781-3742z"
      style={{
        fill: "#1c1b17",
        stroke: "#1c1b17",
        strokeWidth: 512.82,
        strokeLinecap: "round",
        strokeLinejoin: "round",
      }}
      className="stroke1 fill"

    />
  </svg>
)
export default SvgComponent
